import { requestStyles } from '../api/requests/requestStyles';
import { injectAppStyles } from './injectAppStyles';

export const fetchAndInjectAppStyles = async (
  styleIds: string[] | undefined,
  token: string | null
): Promise<void> => {
  if (!styleIds || styleIds.length === 0) {
    injectAppStyles('');
    return;
  }

  const requests = styleIds.map(async (id) => {
    try {
      const css = await requestStyles(id, token);
      return typeof css === 'string' ? css : '';
    } catch (e) {
      console.error(`Failed to fetch app style "${id}"`, e);
      return '';
    }
  });

  const results = await Promise.all(requests);

  injectAppStyles(results.filter(Boolean).join('\n'));
};
